/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import ProstateMRI from "../../../../assets/final-images/servicepage/prostate-page/Artboard 1.jpg";
import ProstateMRI2 from "../../../../assets/final-images/servicepage/prostate-page/Artboard 2.jpg";
import ProstateMRI3 from "../../../../assets/final-images/servicepage/prostate-page/Artboard 3.jpg";
import shapeImage from "../../../../assets/final-images/shapes/7-01-01.png";
import shapeImage2 from "../../../../assets/final-images/shapes/abstruct_2.png";
import NaturalMen from "../../../../assets/final-images/servicepage/prostate-page/about_big.jpg";
import { Link } from "react-router-dom";
import { useLenis } from "../../../SmoothScroll";
import DoneIcon from "@mui/icons-material/Done";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Faqs from "../../../Faqs";
import { Helmet } from "react-helmet-async";
export default function ProstateImaging() {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  const faqs = [
    {
      question:
        "What imaging options are available for prostate evaluation at Citrus Diagnostic Center?",
      answer:
        "Citrus Diagnostic Center offers two advanced prostate imaging modalities: multiparametric prostate MRI (mpMRI) for detection, characterization, and local staging of prostate cancer and biopsy guidance; and PSMA PET/CT (Prostate-Specific Membrane Antigen) - a highly sensitive nuclear medicine scan for detecting prostate cancer spread and biochemical recurrence missed by conventional imaging.",
    },
    {
      question:
        "What is a multiparametric prostate MRI (mpMRI) and when is it ordered?",
      answer:
        "Multiparametric prostate MRI combines T2-weighted, diffusion-weighted (DWI), and dynamic contrast-enhanced (DCE) imaging to comprehensively evaluate the prostate. It is ordered prior to biopsy to identify suspicious lesions and guide targeted biopsy, to stage newly diagnosed prostate cancer, evaluate extracapsular extension or seminal vesicle involvement, and monitor patients on active surveillance. Findings are reported using the standardized PI-RADS scoring system.",
    },
    {
      question:
        "What is PSMA PET/CT and how is it different from a standard PET/CT?",
      answer:
        "PSMA PET/CT uses a radiotracer that targets PSMA - a protein highly expressed on prostate cancer cells - with exceptional sensitivity, even at very low PSA levels. It is FDA-approved for initial staging of high-risk prostate cancer and for detecting biochemical recurrence when PSA rises after surgery or radiation but conventional imaging is negative. PSMA PET has revolutionized prostate cancer management.",
    },
    {
      question: "What is PI-RADS scoring on a prostate MRI?",
      answer:
        "PI-RADS (Prostate Imaging Reporting and Data System) scores suspicious lesions from 1 to 5: scores of 1–2 indicate very low likelihood of clinically significant cancer; 3 is equivocal; 4–5 indicate high suspicion for clinically significant prostate cancer and typically prompt biopsy recommendation. PI-RADS scoring helps urologists and patients make more informed decisions about biopsy.",
    },
    {
      question:
        "How should I prepare for a prostate MRI at Citrus Diagnostic Center?",
      answer:
        "Preparation typically includes avoiding ejaculation for 48 to 72 hours prior, a bowel preparation (Fleet enema the morning of) to reduce rectal artifacts, and a moderately full bladder at time of imaging for some protocols. If contrast is ordered, kidney function history will be reviewed. Our staff will provide complete individualized instructions when you schedule.",
    },
  ];
  return (
    <>
    <Helmet>

       <title>Prostate MRI and Imaging for Cancer Detection | Crystal River

</title>
        <meta
          name="description"
          content="Multiparametric prostate MRI supports accurate detection, staging and treatment planning, with detailed evaluation aligned to clinical context and reporting.
"
        />
        <meta
          name="keywords"
          content="prostate on mri
mri scan prostate
prostate cancer mri
mri prostate imaging
Prostate cancer detection


"
        />
    </Helmet>
      <div>
        <div className=" font-robout">
          <div className="flex flex-col justify-center items-center px-5 xl:px-0 xl:pb-24 xl:pt-36 text-center">
            <h1
              data-aos="fade-right"
              className="font-heading lg:text-[72px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal capitalize"
            >
              Prostate Imaging at Citrus Diagnostic Center
            </h1>
            <p
              data-aos="fade-right"
              data-aos-delay="100"
              className=" text-[#cccccc] font-normal "
            >
              Precision that guides confident care.
            </p>
          </div>
        </div>

        <div className="max-w-[90%] mx-auto xl:my-10">
          <div className="relative xl:bg-[#0f0f0f] rounded-xl py-10 xl:py-32 xl:my-10">
            <img
              src={shapeImage}
              alt="Citrus Diagnostic Center"
              className="
                absolute 
                top-1/2 
                left-1/2 
                -translate-x-1/2 
                -translate-y-1/2 
                pointer-events-none 
                z-0
                opacity-75
                
              "
            />
            <div
              className=" backdrop-blur-[2px]
    bg-[#ffffff13] rounded-xl
      shadow-lg w-full xl:w-[80%] mx-auto py-8 xl:py-16"
            >
              <div className="py-10 text-center flex flex-col items-center ">
                <div className="pb-8">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading capitalize ">
                    A Center of Excellence in Prostate Imaging
                  </h2>

                  <p className=" text-[#cccccc] font-normal">
                    Prostate cancer imaging has evolved rapidly-and precision
                    matters more than ever.
                  </p>
                </div>
                <p className="pb-2 max-w-[700px]">
                  Citrus Diagnostic Center is{" "}
                  <span className="font-extrabold">
                    a regional leader in prostate imaging
                  </span>
                  , combining:
                </p>

                {/* ✅ Centered list but left-aligned content */}
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 text-left">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span className="font-extrabold">
                      Fellowship-trained expertise
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span className="font-extrabold">
                      Multiparametric Prostate MRI
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span className="font-extrabold">
                      Advanced PET imaging (PSMA and non-PSMA)
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span className="font-extrabold">
                      Integrated interpretation across modalities
                    </span>
                  </li>
                </ul>
                <p className="py-2 max-w-[700px]">
                  This is prostate imaging designed to support{" "}
                  <span className="font-extrabold">
                    accurate diagnosis, staging, treatment planning, and
                    long-term care
                  </span>
                  -guided by radiologists with deep clinical and academic
                  experience.
                </p>
              </div>
            </div>
          </div>
          <div className=" bg-[#0f0f0f] p-5 xl:p-10 rounded-xl">
            <div className="grid grid-col-1 xl:grid-cols-2 xl:gap-20  gap-10 xl:py-10 ">
              <div className="p-8">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize pb-8">
                  Why Prostate Imaging Requires Expertise
                </h2>
                <p className="pb-2">
                  Optimal prostate cancer imaging is not about choosing one
                  test.
                </p>
                <p className="pb-2">
                  It’s about knowing{" "}
                  <span className="font-extrabold">
                    when to use MRI, when to use PET, and how to interpret them
                    together.
                  </span>
                </p>
                <p className="pb-2">At Citrus Diagnostic Center:</p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Protocols are{" "}
                      <span className="font-extrabold">
                        radiologist-designed
                      </span>
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Imaging is{" "}
                      <span className="font-extrabold">
                        clinically tailored
                      </span>
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Studies are interpreted in{" "}
                      <span className="font-extrabold">
                        full medical context
                      </span>
                    </span>
                  </li>
                </ul>
                <p className="py-2">
                  This approach mirrors leading academic prostate imaging
                  programs-delivered locally.
                </p>
              </div>
              <div className="bg-[#000] rounded-xl p-8">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize pb-8">
                  What Makes Our Prostate MRI Different
                </h2>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Interpreted by a{" "}
                      <span className="font-extrabold">
                        fellowship-trained radiologist with specialized prostate
                        imaging expertise
                      </span>
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      High-resolution imaging on{" "}
                      <span className="font-extrabold">
                        research-grade Siemens MRI systems
                      </span>
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>PI-RADS–based interpretation</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Careful correlation with PSA, biopsy history, and clinical
                      findings
                    </span>
                  </li>
                </ul>
                <p className="py-2">
                  Prostate MRI provides detailed assessment of:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                  <li className="flex items-start gap-3">
                    <KeyboardArrowRightIcon className="mt-[4px] text-[#bf9c5e] shrink-0" />
                    <span>Tumor location</span>
                  </li>

                  <li className="flex items-start gap-3">
                    <KeyboardArrowRightIcon className="mt-[4px] text-[#bf9c5e] shrink-0" />
                    <span>Tumor extent</span>
                  </li>

                  <li className="flex items-start gap-3">
                    <KeyboardArrowRightIcon className="mt-[4px] text-[#bf9c5e] shrink-0" />
                    <span>Extraprostatic extension</span>
                  </li>

                  <li className="flex items-start gap-3">
                    <KeyboardArrowRightIcon className="mt-[4px] text-[#bf9c5e] shrink-0" />
                    <span>Seminal vesicle involvement</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="grid grid-col-1 xl:grid-cols-2 xl:gap-20 gap-10 ">
              <div className="flex justify-center items-center order-2 xl:order-1">
                <img
                  alt=" Oncology PET-CT"
                  className="rounded-3xl w-auto h-auto"
                  src={ProstateMRI}
                />
              </div>
              <div className="flex flex-col justify-center items-start p-5 xl:px-0 order-1 xl:order-2">
                <div className="pb-8">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                    Multiparametric Prostate MRI
                  </h2>
                  <p className=" text-[#cccccc] font-normal">
                    The foundation of modern prostate imaging.
                  </p>
                </div>
                <p className="pb-2">
                  Multiparametric prostate MRI plays a central role in:
                </p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Cancer detection</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Local staging</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Active surveillance</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Treatment planning</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Post-treatment evaluation</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            background:
              "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
          }}
        >
          <div className="max-w-[90%] mx-auto">
            <div className="text-center pb-10 xl:pt-16 pt-12">
              <div className="pb-8">
                <h2 className="font-heading lg:text-[52px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal text-center  capitalize ">
                  Prostate PET Imaging
                </h2>
                <p className=" text-[#cccccc] font-normal">
                  Molecular insight beyond anatomy.
                </p>
              </div>
              <p className="pb-2">
                PET imaging has become a critical tool in prostate cancer
                care-especially for{" "}
                <span className="font-extrabold">
                  initial staging and biochemical recurrence.
                </span>
              </p>
            </div>
            <div className="grid grid-col-1 xl:grid-cols-2 xl:gap-20 gap-10 py-8">
              <div className=" 2xl:px-12 xl:py-10 xl:px-8 flex justify-center items-start flex-col">
                <h3 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  pb-8">
                  PSMA Prostate PET-CT
                </h3>
                <p className="pb-2">PSMA-based PET imaging is used to:</p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Stage newly diagnosed prostate cancer</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Evaluate biochemical recurrence</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Detect metastatic disease at very low PSA levels
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Guide treatment decisions</span>
                  </li>
                </ul>
                <p className="py-2">
                  PSMA PET-CT offers sensitivity beyond conventional imaging and
                  is increasingly considered{" "}
                  <span className="font-extrabold">standard of care</span> in
                  appropriate clinical settings.
                </p>
              </div>
              <div className="flex flex-col justify-center items-start">
                <div className="pb-8">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                    Non-PSMA Prostate PET-CT
                  </h2>
                  <p className=" text-[#cccccc] font-normal">
                    Not all prostate cancer biology is the same.
                  </p>
                </div>
                <p className="pb-2">Non-PSMA PET-CT may be utilized for:</p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Biochemical recurrence</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Cases where PSMA imaging is not appropriate</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Specific clinical scenarios based on disease behavior
                    </span>
                  </li>
                </ul>

                <p className="py-2">
                  Offering both PSMA and non-PSMA PET imaging reflects a{" "}
                  <span className="font-extrabold">
                    nuanced, patient-specific approach
                  </span>
                  , rather than a one-size-fits-all strategy.
                </p>
              </div>
            </div>
            <div className="grid grid-col-1 xl:grid-cols-2 xl:gap-20 gap-10 xl:pb-20 pb-10 xl:pt-10">
              <div className=" xl:py-10 2xl:px-12 xl:px-8  flex justify-center items-start flex-col">
                <div className="pb-8">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                    Integrated Prostate Imaging Strategy
                  </h2>
                  <p className=" text-[#cccccc] font-normal">
                    MRI + PET, interpreted together.
                  </p>
                </div>
                <p className="pb-2">
                  The greatest value in prostate imaging comes from{" "}
                  <span className="font-extrabold">integration</span>.
                </p>
                <p className="pb-2">At Citrus Diagnostic Center:</p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Prostate MRI and PET-CT findings are correlated</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Imaging is interpreted by radiologists experienced in both
                      modalities
                    </span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Reports emphasize clinically actionable insights
                    </span>
                  </li>
                </ul>

                <p className="py-2">This integrated approach supports:</p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Accurate staging</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Targeted therapy planning</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Avoidance of unnecessary procedures</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Informed shared decision-making</span>
                  </li>
                </ul>
              </div>
              <div>
                <img
                  alt="  Integrated Prostate Imaging Strategy"
                  className="rounded-3xl w-auto h-auto "
                  src={ProstateMRI2}
                />
              </div>
              <div className="order-2 xl:order-1">
                <img
                  alt=" Advanced Prostate Imaging"
                  className="rounded-3xl w-auto h-auto"
                  src={ProstateMRI3}
                />
              </div>
              <div className="flex flex-col justify-center items-start order-1 xl:order-2 ">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize pb-8 ">
                  Who Benefits from Advanced Prostate Imaging
                </h2>
                <p className="pb-2">Prostate imaging may be recommended for:</p>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Newly diagnosed prostate cancer</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Elevated or rising PSA</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Biochemical recurrence after treatment</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Active surveillance monitoring</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Treatment planning and response assessment</span>
                  </li>
                </ul>
                <p className="py-2">
                  Imaging selection is guided by{" "}
                  <span className="font-extrabold">
                    clinical indication, risk stratification, and evidence-based
                    practice
                  </span>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-[90%] mx-auto">
          <div className="rounded-xl  xl:pt-20 pt-10">
            <img alt="Natural_photo CDC" src={NaturalMen} className="rounded-xl " />
          </div>
        </div>
        <div className="relative py-16 ">
          <img
            src={shapeImage2}
            alt="CDC Florida"
            className="
      absolute 
      top-1/2 
      left-1/2 
      -translate-x-1/2 
      -translate-y-1/2 
      pointer-events-none 
      z-0
      opacity-45
      
    "
          />
          <div className="max-w-[90%] mx-auto bg-[#0f0f0f] rounded-xl xl:p-24">
            <div className="">
              <div
                className="grid grid-col-1 xl:grid-cols-2 xl:gap-20 gap-10 xl:pb-10 pt-10 xl:pt-20 backdrop-blur-[2px]
     bg-[linear-gradient(#ffffff0d_0%,#ffffff14_100%)]
      border border-[#ffffff49] rounded-xl
      shadow-lg p-10"
              >
                <div className="">
                  <div className="pb-8">
                    <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                      For Urologists & Referring Providers
                    </h2>
                    <p className=" text-[#cccccc] font-normal">
                      Imaging designed for clinical decision-making.
                    </p>
                  </div>
                  <p className="pb-2">Citrus Diagnostic Center provides:</p>
                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>
                        Fellowship-level prostate imaging interpretation
                      </span>
                    </li>

                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Evidence-based protocols</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Clear, structured, actionable reports</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Access to both MRI and advanced PET imaging</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Direct radiologist collaboration when needed</span>
                    </li>
                  </ul>
                  <p className="py-2">
                    We support urologists, oncologists, and primary care
                    providers with imaging that{" "}
                    <span className="font-extrabold">
                      adds clarity-not complexity
                    </span>
                    .
                  </p>
                </div>
                <div className="">
                  <div className="pb-8">
                    <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  ">
                      For Patients
                    </h2>
                    <p className=" text-[#cccccc] font-normal">
                      Knowledge, choice, and confidence.
                    </p>
                  </div>
                  <p className="pb-2">
                    Prostate imaging can feel overwhelming. Our team
                    prioritizes:
                  </p>
                  <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Clear explanations</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Thoughtful exam selection</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Respect for patient choice</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Compassionate care throughout the process</span>
                    </li>
                  </ul>
                  <p className="py-2">
                    Patients receive personalized preparation instructions and
                    secure access to reports through our modern patient
                    communication systems.
                  </p>
                </div>
              </div>
              <div
                className=" backdrop-blur-[2px]
     bg-[linear-gradient(#ffffff0d_0%,#ffffff14_100%)]
      border border-[#ffffff49] rounded-xl
      shadow-lg p-10 mt-10 xl:mt-20"
              >
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize  pb-8">
                  Why Choose Citrus Diagnostic Center for Prostate Imaging
                </h2>
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Radiologist owned and operated</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Fellowship-trained prostate imaging expertise</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Multiparametric Prostate MRI</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>PSMA and non-PSMA PET-CT options</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Integrated MRI + PET interpretation</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Academic-level imaging, delivered locally</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[80%] w-[90%] mx-auto pb-10 ">
          <Faqs faqs={faqs} />
        </div>
        <div className="max-w-[90%] mx-auto">
          <div className="flex justify-center items-center py-10">
            <div
              style={{
                background: `
    linear-gradient(90deg,#3d0e26 0%, #5a1f33 1%, #8b5e3c 40%,#8b5e3c 70%,#5a1f33 95%, #330a16 100%)`,
              }}
              className="flex justify-center items-center flex-col xl:w-[668px] py-8 px-6 xl:px-8 rounded-xl"
            >
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading texc  capitalize  ">
                Schedule with Confidence
              </h2>
              <p className="text-center pt-5 px-4">
                Advanced prostate imaging-guided by expertise, precision, and
                patient-first care.
              </p>
              <div className="pt-10 pb-4">
                <Link
                  data-aos="fade-up"
                  to="/contact-us"
                  aria-label="Schedule Now"
                  className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold text-[17px] hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
                >
                  Schedule Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
